<template>
   <div class="sl-item">
			<a>
				<div class="sl-avatar avatar avatar-sm avatar-circle">
					<img class="img-responsive img-circle" src="static/avatar.png" alt="avatar">
				</div>
				<div class="sl-content">
					<p class="inline-block"><span class="capitalize-font txt-orange mr-5 weight-500">{{cardData.user_name}}</span><span>{{cardData.message}}</span></p>
					<span class="block txt-grey font-12 capitalize-font">{{cardData.created_at | moment("YYYY-MM-DD HH:mm")}}</span>
				</div>
			</a>
		</div>
</template>
<script>

export default {
  name: "ActivityFeedCard",
  components: {
  },
  props: {
		cardData: {
			type: Object,
			required: true
		}
	},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
	}
};
</script>

<style lang="scss" scopred>
.sl-item {
	padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/ActivityFeedCard.vue